module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'filter',
    ],

    // config: {
    //     tableComponentClass: 'templates_office_projects_table', // e.g., templates_globals_userSessions_userSessions_table
    //     controllerComponentClass: '' // e.g., templates_globals_userSessions_entity_controller
    // }
}